(ns app.front.view.group.admin.verdict-template.events
  (:require [app.front.entities :as entities]
            [clojure.string :as str]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::set-section-language
  (fn [_ [_ group-id section-id language]]
    {:comm/command {:command    :group/set-verdict-template-section-language
                    :method     :post
                    :data       (util/mmap group-id section-id language)
                    :notify     {:success :template-editor/language-changed}
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-fx ::delete-section
  (fn [_ [_ group-id section-id]]
    {:comm/command {:command    :group/delete-verdict-template-section
                    :method     :post
                    :data       (util/mmap group-id section-id)
                    :on-success [::entities/remove-from-entity-db]}}))

(rf/reg-event-fx ::copy-section
  (fn [_ [_ group-id section-id]]
    {:comm/command {:command    :group/copy-verdict-section
                    :method     :post
                    :data       (util/mmap group-id section-id)
                    :notify     {:success :template-editor/page-copied}
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-fx ::update-section.success
  (fn [_ [_ on-success status resp]]
    {:dispatch-n [[::entities/override-entity-db status resp]
                  (or on-success
                      [:notifications/add :toast :success :success ""])]}))

(rf/reg-event-fx ::update-section
  (fn [_ [_ group-id section-id updates & [on-success]]]
    {:comm/command {:command    :group/update-verdict-template-section
                    :method     :post
                    :data       (merge {:group-id   group-id
                                        :section-id section-id}
                                       updates)
                    :on-success [::update-section.success on-success]}}))


(rf/reg-event-fx ::set-label-translation-command
  (fn [_ [_ group-id section-id label]]
    {:comm/command {:command    :group/set-verdict-template-section-label
                    :method     :post
                    :data       (util/mmap group-id section-id label)
                    :notify     {:success :template-editor/label-changed}
                    :on-success [::entities/apply-changes]}}))


(rf/reg-event-fx ::set-label-translation
  (fn [_ [_ group-id section-id label]]
    {:dispatch-debounce [{:id      (str/join "." [group-id section-id])
                          :timeout 500
                          :action  :dispatch
                          :event   [::set-label-translation-command group-id section-id label]}]}))
